var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03162 0.936771C6.21648 -0.332726 8.90203 -0.310537 11.0664 0.994894C13.2095 2.32691 14.512 4.70418 14.4998 7.26144C14.45 9.80194 13.0533 12.19 11.3075 14.0361C10.2998 15.1064 9.17261 16.0528 7.94884 16.856C7.82281 16.9289 7.68475 16.9777 7.54148 17C7.4036 16.9941 7.26932 16.9534 7.15075 16.8814C5.28243 15.6746 3.64334 14.134 2.31233 12.334C1.19859 10.8314 0.565836 9.01601 0.500001 7.13442C0.498555 4.57225 1.84677 2.20627 4.03162 0.936771ZM5.29416 8.19478C5.66168 9.10084 6.52918 9.69184 7.4916 9.69185C8.1221 9.69638 8.72819 9.44383 9.17481 8.99048C9.62143 8.53712 9.87148 7.92064 9.86925 7.27838C9.87261 6.29804 9.29546 5.41231 8.40726 5.03477C7.51907 4.65723 6.49504 4.86235 5.81332 5.55435C5.13159 6.24635 4.92664 7.28872 5.29416 8.19478Z",
    fill: "#130F26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2cc3ae7fc08256958999d8c31473ebef.svg";
export { ForwardRef as ReactComponent };